import { ssrHotels } from '@dbh/hotels-redux';

var reducersAndSagas = [ssrHotels];

export { reducersAndSagas as default };
